// @flow
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import FavoriteSlider from './FavoriteSlider';
import SectionsList from './SectionsList';
import BannerLateral from './BannerLateral';

const Column = styled.div`
`;

const SectionsContainer = Column.extend`
  flex: 0 0 20%;
  margin-top: 90px;
  padding-right: 10px;
`;

const Content = Column.extend`
  flex: 0 0 80%;
  margin-top: 20px;
`;

const Main = styled.main`
  display: flex;
  max-width: 1024px;
  margin: auto;
`;

class BuildingsView extends PureComponent {
  props: {
    children: React$Element<any>,
  }

  render() {
    return (
      <div>
        <FavoriteSlider />
        <Main>
          <SectionsContainer>
            <SectionsList />
            <BannerLateral />
          </SectionsContainer>
          <Content>
            {this.props.children}
          </Content>
        </Main>
      </div>
    )
  }
}

export default BuildingsView;



// WEBPACK FOOTER //
// ./src/components/HomeLayout/index.js